import { graphql } from "react-relay";

export const modernWrapperFragments = {
  viewer: graphql`
    fragment ModernWrapper_viewer on Viewer {
      id
      user {
        id
        status
        emails
        givenName
        familyName
        createdTime
        rolloutProperties
        members {
          value
          scope {
            type
            value
          }
        }
        webAppFlagsErrorable {
          __typename
          ... on GraphEntityError {
            statusCode
            message
          }
          ... on Flags {
            flags
          }
        }
        orgs(first: 1000000) {
          edges {
            node {
              id
              experiments
              createdTime
              name
              ecosystem
            }
          }
        }
      }
    }
  `,
};

export const modernWrapperQuery = graphql`
  query ModernWrapperQuery {
    viewer {
      ...ModernWrapper_viewer
    }
  }
`;
